import React from "react";
import { TextField } from "cayo.ui";
import { Checkbox } from "@fluentui/react";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { smtpWizardMessages } from "../messages";

type ConfigureServerProps = {
  server: string;
  port: string;
  tls: boolean;
  user: string;
  password: string;
  handleChange: (key: string, value: string | boolean) => void;
};

export const ConfigureServer = ({
  server,
  port,
  tls,
  user,
  password,
  handleChange,
}: ConfigureServerProps) => {
  const intl = useIntl();

  return (
    <div>
      <TextField
        label={intl.formatMessage(smtpWizardMessages.mailServerAddress)}
        required
        value={server}
        setValue={(value) => handleChange("server", value)}
      />

      <TextField
        label={intl.formatMessage(smtpWizardMessages.mailServerPort)}
        required
        value={port}
        setValue={(value) => handleChange("port", value)}
      />

      <CheckBoxesWrap>
        <Checkbox
          checked={tls}
          id="mentionTeam"
          label={intl.formatMessage(smtpWizardMessages.tls)}
          onChange={(_, checked) => handleChange("tls", !!checked)}
        />
      </CheckBoxesWrap>

      <TextField
        label={intl.formatMessage(smtpWizardMessages.userNameField)}
        value={user}
        setValue={(value) => handleChange("user", value)}
      />

      <TextField
        type="password"
        isConfidential
        label={intl.formatMessage(smtpWizardMessages.passwordField)}
        value={password}
        setValue={(value) => handleChange("password", value)}
      />
    </div>
  );
};

const CheckBoxesWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px 0;
`;
